import Api from '@/api/index';

const Check = {
  namespaced: true,
  state: {
    allChecks: [],
    statusByTitle:{}
  },
  getters: {
    
  },

  mutations: {
    setAllChecks(state, checks) {
      state.allChecks = [...checks]
    }
  },

  actions: {
    index(context, filters) {
      return Api.Check.index(filters).then(r => r.data).then(r => {
        context.commit('setAllChecks', r.data)
        return true
      }).catch(err => {
        console.log(err)
        throw Error(err)
      })
    }
  }

};

export default Check;
